import { render, staticRenderFns } from "./PaperDetail.vue?vue&type=template&id=61b0a208&scoped=true"
import script from "./PaperDetail.vue?vue&type=script&lang=js"
export * from "./PaperDetail.vue?vue&type=script&lang=js"
import style0 from "./PaperDetail.vue?vue&type=style&index=0&id=61b0a208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0a208",
  null
  
)

export default component.exports